// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39VGv","clinicsSelect":"styles_clinicsSelect__2q2p6"};